import PageHero from '../components/PageHero';
import { oekonomiskDetails } from '../data';
import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function OekonomiskRaadgivning() {
  return (
    <main className="bg-white">
      <SEO 
        title="Økonomisk Rådgivning | Budget, Likviditet & KPI-Analyser – FINANJU"
        description="Få strategisk økonomisk overblik, budgettering, likviditetsstyring og rapportering med FINANJUs økonomiske rådgivning. Styrk din forretning i dag."
        path="/oekonomisk-raadgivning"
      />
      <PageHero
        title="Økonomisk Rådgivning"
        subtitle="Få strategisk overblik og optimer din virksomheds økonomiske fundament for sund vækst."
        breadcrumbs={[
          { name: 'Ydelser', href: '/ydelser' },
          { name: 'Økonomisk rådgivning', href: '/oekonomisk-raadgivning' }
        ]}
      />

      <section className="py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center mb-16">
            <div>
              <h2 className="text-3xl font-bold text-slate-900 mb-8">Styrk din forretning med økonomisk overblik</h2>
              <p className="text-lg text-slate-500 leading-relaxed mb-6">
                En sund økonomi handler ikke kun om at holde styr på fortiden, men i høj grad om at planlægge fremtiden. Hos FINANJU hjælper vi dig med at omsætte komplekse tal til konkrete, strategiske beslutninger.
              </p>
              <p className="text-lg text-slate-500 leading-relaxed mb-10">
                Vi tilbyder skræddersyet rådgivning, der passer til netop din virksomheds størrelse og ambitioner. Uanset om du har brug for sparring om budgetter, likviditetsstyring eller dybdegående KPI-analyser, står vi klar.
              </p>
              <div className="space-y-6">
                {oekonomiskDetails.map((detail, idx) => (
                  <div key={idx} className="flex gap-4">
                    <div className="mt-1">
                      <CheckCircle2 className="h-6 w-6 text-[#876a57]" />
                    </div>
                    <div>
                      <h3 className="font-bold text-slate-900 mb-1">{detail.title}</h3>
                      <p className="text-slate-500">{detail.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-16 lg:mt-0 relative">
              <div className="aspect-[4/3] rounded-sm overflow-hidden bg-slate-100 shadow-2xl">
                <img
                  src="/images/office-desk-creative-setup.png"
                  alt="Professionelt kontormiljø med computer og dokumenter"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Dark CTA Box */}
          <div className="bg-slate-900 rounded-sm p-12 lg:p-16 text-center shadow-lg relative overflow-hidden">
             <div className="absolute inset-0 z-0">
                <img
                  src="/images/consultation.png"
                  alt="Background"
                  className="w-full h-full object-cover opacity-10 grayscale mix-blend-multiply"
                />
             </div>
             <div className="relative z-10">
                <h3 className="text-2xl font-bold text-white mb-6">Få skræddersyet en løsning</h3>
                <p className="text-slate-300 mb-10 max-w-2xl mx-auto">
                  Lad os tage en uforpligtende dialog om, hvordan vi kan styrke din virksomheds økonomiske fundament.
                </p>
                <Link to="/kontakt?emne=økonomisk-rådgivning" className="cta-button">
                  Kontakt FINANJU
                </Link>
             </div>
          </div>
        </div>
      </section>
    </main>
  );
}
